/**
 * Get a string meaningful value
 *
 * @param value
 * @returns {string}
 */
function normalizeString(value) {
  if (value === null || value === undefined) {
    return '';
  }

  return value.toString().trim();
}

/**
 * Capitalize string
 *
 * @param value
 * @returns {string}
 */
function capitalize(value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

/**
 * Get text content from html
 *
 * @param html
 * @returns {string | string}
 */
function htmlToText(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  // handle p
  doc.querySelectorAll('p').forEach((element) => {
    element.parentElement.insertBefore(document.createTextNode('\n\n'), element.nextSibling);
  });

  // handle br
  doc.querySelectorAll('br').forEach((element) => {
    element.parentElement.insertBefore(document.createTextNode('\n'), element.nextSibling);
  });

  return doc.body.textContent.trim();
}

function extractTagsFromHtml(html) {
  if (!html || html === '') {
    return '';
  }

  const regex = /<span [^>]+>(#.*?)<\/span>/gi;

  const tags = [...html.matchAll(regex)];

  let content = tags.map((tag) => tag[1]).join(' ');

  let filteredContent = content.replace(',', ' ').replace('.', ' ').replace(';', ' ').replace('\n', ' ').trim();
  let hashTags = filteredContent.split(/\s/).filter((item) => !!item && item !== '' && item.charAt(0) === '#');

  return hashTags.map((tag) => tag.replace('#', ''));
}

export { normalizeString, capitalize, htmlToText, extractTagsFromHtml };
